import styled from 'styled-components';

export const Input = styled.input`
  appearance: none;
  box-sizing: border-box;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin: 3px;
  background-color: transparent;
  border: 2px solid #637381;
  border-radius: 50%;
  outline: none;
  cursor: pointer;
  flex-shrink: 0;

  transition: box-shadow 0.1s;

  &:checked {
    position: relative;
    border-color: #0079d1;
  }

  &:checked::before {
    content: '';
    width: 10px;
    height: 10px;
    position: absolute;
    top: 2px;
    left: 2px;
    background-color: #0079d1;
    border-radius: 50%;
  }

  &:hover {
    border-color: #0079d1;
  }

  &:active {
    border-color: #0079d1;
  }

  &:focus {
    box-shadow: 0 0 0 4px #80bce8;
    outline: 0;
  }

  &:disabled {
    box-shadow: none;
    background-color: #dfe3e8;
    border-color: #959fa8;
    cursor: default;
  }

  &:disabled::before {
    background-color: #637381;
  }
`;
